(() => {
  'use strict';

  const initialize = (root) => {
    if (root.dataset.servicesReady === 'true') return;
    const controls = root.querySelector('[data-services-controls]');
    const buttons = Array.from(root.querySelectorAll('[data-service-filter]'));
    const items = Array.from(root.querySelectorAll('[data-service-item]'));
    const grid = root.querySelector('[data-services-grid]');
    const status = root.querySelector('[data-services-status]');
    const empty = root.querySelector('[data-services-empty]');
    const reset = root.querySelector('[data-services-reset]');
    if (!controls || !buttons.length || !grid || !status || !empty) return;

    const applyFilter = (category) => {
      const selected = buttons.find((button) => button.dataset.serviceFilter === category)
        || buttons.find((button) => button.dataset.serviceFilter === 'all');
      if (!selected) return;
      const activeCategory = selected.dataset.serviceFilter;
      let visible = 0;
      items.forEach((item) => {
        item.hidden = activeCategory !== 'all' && item.dataset.serviceCategory !== activeCategory;
        if (!item.hidden) visible += 1;
      });
      buttons.forEach((button) => button.setAttribute('aria-pressed', String(button === selected)));
      grid.hidden = !items.some((item) => !item.hidden && grid.contains(item));
      empty.hidden = visible > 0;
      root.dataset.servicesCategory = activeCategory;
      status.textContent = (root.dataset.servicesStatusTemplate || '[visible] / [total]')
        .replace('[visible]', String(visible))
        .replace('[total]', String(items.length))
        .replace('[category]', selected.dataset.serviceFilterLabel || '');
    };

    buttons.forEach((button) => {
      const category = button.dataset.serviceFilter;
      const count = category === 'all' ? items.length
        : items.filter((item) => item.dataset.serviceCategory === category).length;
      const badge = button.querySelector('[data-service-filter-count]');
      if (badge) badge.textContent = String(count);
      button.addEventListener('click', () => applyFilter(category));
    });
    if (reset) reset.addEventListener('click', () => {
      applyFilter('all');
      const all = buttons.find((button) => button.dataset.serviceFilter === 'all');
      if (all) all.focus();
    });
    applyFilter('all');
    controls.hidden = false;
    root.dataset.servicesReady = 'true';
  };

  const initializeWithin = (scope) => {
    if (scope.matches && scope.matches('[data-services]')) initialize(scope);
    scope.querySelectorAll('[data-services]').forEach(initialize);
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeWithin(document), { once: true });
  } else {
    initializeWithin(document);
  }
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
